import { useContext, useEffect, useState } from 'react'
import { Col, Container, Form, Row, Table } from "react-bootstrap";
import 'react-bootstrap-typeahead/css/Typeahead.css'
import ReactJson from 'react-json-view'
import { getRoles } from '../../../../services/users'
import { showMessage, showValidatePassword } from '../../../../shared/Alerts'
import { PartnerContext } from '../PartnerContexts'


const InfoModalForm = () => {
  const {setIsInfoModalOpen,setUpdateUser,infoData, setSearchTerm} = useContext(PartnerContext)

  const [candidatos, setCandidatos] = useState<any[]>([]);
  const [loading, setLoading] = useState(false)
  const [dataInfo, setDataInfo] = useState<any>(infoData)
  const [acceptExt, setAcceptExt] = useState('.docx'); 
  const [shouldClear, setShouldClear] = useState(false);
  const [cargandoFile, setCargandoFile] = useState(false);
  const [listRoles, setListRoles] = useState<any[]>()
  const [selected, setSelected] = useState<any[]>()
  const [listProcessValidationError, setListProcessValidationError] = useState(false)
  const [userRoleSelected, setUserRoleSelected] = useState<string[]>([]);

  useEffect(()=>{
    setDataInfo(dataInfo)
  },[dataInfo])

  useEffect(()=>{
    obtenerRoles()
  },[])
  useEffect(() => {
    setCandidatos(infoData?.CandidatosSeleccionados || []);
  }, [infoData]);


  const handleActualizarUser = () => {
    setLoading(true)
    const data = {
      rol: userRoleSelected
    }

    showValidatePassword().then(async (result) => {      
      if (result.isConfirmed) {

      }
    })
    .catch((error) => {
      console.log(error)
      setLoading(false)
    })
    
  }

  const obtenerRoles = () =>{
    getRoles()
        .then((response:any) => {
          if (response.success) {
            const rolesAll = response.data?.map((x: any) => ({ label: x.nombre_perfil, value: x.rol }))
            const select:any[] = rolesAll?.filter((x: any) => dataInfo.rol.includes(x.label))
            setSelected(select)
            setListRoles(rolesAll)
            setUserRoleSelected(select.map(s => s.value))
          } else {
            console.log(response)
            showMessage('error', 'Hubo un error', response.error)
          }
        })
        .catch((error:any) => {
          console.log(error)
        })
  }

  const limpiarCampos = ()=>{    
    setDataInfo({ _id:'',idproceso:'', name: '', file: '', filename: '', keyname: '', type:'PLANTILLA' })         
    setShouldClear(true);
  }


  const handleSelectChange = (e: any) => {
    setSelected(e)
    setUserRoleSelected(e.map((x: any) => x.value))
    processOwnersValidation(e.map((x: any) => x.value))
  }

  const processOwnersValidation = (owners: string[]) => {
    if (owners.length === 0) {
      setListProcessValidationError(true)
    } else {
      setListProcessValidationError(false)
    }
  }

  const showEnterpricesOptions = (
    rols: string[],
    rules: string[] = ['ADMINISTRADOR', 'MASTER']
  ): boolean => {
    return rols.some((rol) => rules.includes(rol))
  }

  return (
    <Container>
      <Row className="mb-3 pt-3 px-3">
        <Col sm>
          <div className='table-responsive min-vh-40'>
          <table className='table align-middle table-row-bordered fs-6 table-hover'>
          <thead>
          <tr className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-primary text-white'>
                <td className='p-3'> NRO</td>
                <td>Nombre Completo</td>
                <td>Documento</td>
                <td className='text-start p-3'>Email</td>
              </tr>
            </thead>
            <tbody>
              {candidatos.length > 0 ? (
                candidatos.map((candidato, index) => (
                  <tr key={candidato._id}>
                    <td className='p-3'>{index + 1}</td>
                    <td>
                      {candidato.CS_Nombres} {candidato.CS_ApPaterno} {candidato.CS_ApMaterno}
                    </td>
                    <td>{candidato.CS_Documento}</td>
                    <td className='text-start p-3'>{candidato.CS_EmailPersonal}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="text-center">
                    No hay candidatos seleccionados.
                  </td>
                </tr>
              )}
            </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
export { InfoModalForm };

